module.exports = __webpack_public_path__ + "img/CM-AB-25-INFINITI-Lifestyle.9e3f3c71.jpg";